import type { Prototype } from "../prototype-types";

export const maggieMurphyPrototypes: Prototype[] = [
  {
    id: "demo-caraway",
    name: "Demo Caraway",
    path: "/mm/demo-caraway",
    description:
      "Sales demo fork of Brand Page V4 for Caraway — production-matching retailer brand page layout with real Caraway.com content and retailer-style PDPs.",
    project: "Sales Demo Brand Pages",
    owner: "Maggie Murphy",
    createdAt: "2026-07-21",
    lastUpdated: "2026-07-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/463fbdf976bf753961ce03a7ef23774b000e019077a2ad14989c8abdfb80981d.png",
    creationTool: "claude-code",
  },
  {
    id: "demo-away",
    name: "Demo Away",
    path: "/mm/demo-away",
    description:
      "Prospect demo fork of Brand Page V4 (P.F. Candle Co. production-matching retailer brand page). Starting point for customizing brand pages in sales demos.",
    project: "Sales Demo Brand Pages",
    owner: "Maggie Murphy",
    createdAt: "2026-07-21",
    lastUpdated: "2026-07-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/698a1e303cf0c0f1b1876a66ddbef69790722fe0787be551b750be2d304fdeb5.png",
    creationTool: "claude-code",
  },
  {
    id: "genz-brand-portal-v2",
    name: "Gen-Z Brand Portal V2",
    path: "/mm/genz-brand-portal-v2",
    description:
      "A gen-z / Depop-inspired visual redesign of the brand portal — cream+ink palette, Playfair Display editorial typography, scratch-off cards, slot machine actions, swipe deck, and are.na-style stats.",
    owner: "Maggie Murphy",
    createdAt: "2026-05-01",
    lastUpdated: "2026-05-01",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ddd4be3540e0f4d36872512a745feda6f24261b6dfae83d1a8a21aba4afc5734.png",
  },
  {
    id: "brand-portal-vision",
    name: "Maggie & Martin's Brand Portal Vision",
    path: "/mm/brand-portal-vision",
    description:
      "Maggie and Martin jammed on the future of the brand portal. A future that is actionable, personalized, and delightful.",
    owner: "Maggie Murphy",
    createdAt: "2026-04-27",
    lastUpdated: "2026-04-27",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/19de16f02ea52cfdc3fa27acf9c0c134aaec58b272447e6d2be2af45fa1d19dc.png",
  },
  {
    id: "brand-portal-future",
    name: "Brand Portal Future",
    path: "/mm/brand-portal-future",
    description:
      "Scroll-driven editorial homepage concept for the brand portal — features a customizable sidebar, interactive store location map, dynamic product insights, and scroll-anchored section navigation.",
    owner: "Maggie Murphy",
    createdAt: "2026-04-21",
    lastUpdated: "2026-04-22",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/073935a52cee2fd0eb88ad564d88515cec9702736764cd03ded49a5eb541cbda.png",
  },
  {
    id: "brand-portal-exploration",
    name: "Brand Portal Exploration",
    path: "/mm/brand-portal-exploration",
    description:
      "Exploratory brand portal future concept that feels unique, data-driven, and actionable.",
    owner: "Maggie Murphy",
    createdAt: "2026-04-21",
    lastUpdated: "2026-04-21",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/c17cba851d1add228b2ddcf3cfb3a99f13b4d02ffa7bc17d790816116a3eba2c.png",
  },
  {
    id: "build-your-shop",
    name: "Build Your Shop",
    path: "/mm/build-your-shop",
    description:
      "Interactive prototype for the Build Your Shop onboarding flow for new brands.",
    owner: "Maggie Murphy",
    createdAt: "2026-04-21",
    lastUpdated: "2026-04-22",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2f57f1e443698035ce5203f00eaa59f7bf6039fdaf75440af1af43820a05e5b5.png",
  },
  {
    id: "brand-portal-new-brands",
    name: "Brand Portal for New Brands",
    path: "/mm/brand-portal-new-brands",
    description:
      "A multi-persona exploration of the brand home page for new brands on Faire — 4 personas (Default, Gen-Z Depop, New Yorker, Chair Co.) across 3 phases with persona-specific copy, visual tone, and interaction patterns.",
    owner: "Maggie Murphy",
    createdAt: "2026-04-16",
    lastUpdated: "2026-04-16",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f923abc36b2215fd62a9381281b4a94bef984e8fc4a8b44e88dd42c16d5b18cf.png",
    creationTool: "claude-code",
  },
  {
    id: "r2b-referrals-now-on-faire",
    name: "R2B Referrals on Now on Faire",
    path: "/mm/r2b-referrals-now-on-faire",
    description:
      "On Now on Faire, retailers can see brands they can shop on Faire alongside brands that are not yet on Faire. Retailers will be invited to refer their brands that are not yet on Faire.",
    owner: "Maggie Murphy",
    createdAt: "2026-03-04",
    lastUpdated: "2026-04-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f198a107e152b85c5b3b1bfdb625e309bdd5f9b0ea4e2510a3e8340fc019515d.png",
    creationTool: "cursor",
  },
  {
    id: "mm-mobile-products-page",
    name: "Mobile Products Page",
    path: "/mm/mobile-products-page",
    description:
      "Mobile-web add-products → import → products page flow for brand portal (BRA3-123).",
    project: "Product upload improvements",
    owner: "Maggie Murphy",
    createdAt: "2026-07-28",
    lastUpdated: "2026-07-28",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f19e8808efcf069994db7311cdb83093681ebdc0ee560531113dbfe576b4f5d9.png",
    creationTool: "claude-code",
  },
  {
    id: "mm-one-click-referral",
    name: "One-Click Referral",
    path: "/mm/one-click-referral",
    description:
      "Nopalera retailer brand page with a six-tile “Brands you might like” row (tile 4 swaps between baseline Jao and four BaubleBar referral treatments), a “Popular with stores like yours” product carousel, and ratings & reviews. Live toolbar toggles referral treatment and long/short modal.",
    project: "One-Click Referral",
    owner: "Maggie Murphy",
    createdAt: "2026-08-11",
    lastUpdated: "2026-08-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/mm-one-click-referral.png",
    creationTool: "cursor",
  },
  {
    id: "mm-brand-analytics",
    name: "Brand Analytics",
    path: "/mm/brand-analytics",
    description:
      "Mobile analytics for brands — sales, shop traffic, top products, and Faire Direct.",
    owner: "Maggie Murphy",
    createdAt: "2026-09-28",
    lastUpdated: "2026-09-29",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail: "/images/thumbnails/mm-brand-analytics.png",
    creationTool: "cursor",
  },
  {
    id: "mm-retailer-analytics",
    name: "Retailer Analytics",
    path: "/mm/retailer-analytics",
    description:
      "Mobile analytics for retailers — spend, top brands, and category breakdowns.",
    owner: "Maggie Murphy",
    createdAt: "2026-09-15",
    lastUpdated: "2026-09-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail: "/images/thumbnails/mm-retailer-analytics.png",
    creationTool: "cursor",
  },
  {
    id: "mm-notifications-stress-test",
    name: "Notifications Stress Test",
    path: "/mm/notifications-stress-test",
    description:
      "Brand-side notifications panel stress-tested against real alert volumes — grouping, date headers, P0 CTAs, badging, completed items, truncation, and icon vs. image treatments.",
    owner: "Maggie Murphy",
    createdAt: "2026-09-21",
    lastUpdated: "2026-09-21",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/mm-notifications-stress-test.png",
    creationTool: "cursor",
  },
  {
    id: "mm-retailer-insights",
    name: "Retailer Insights — Web",
    path: "/mm/retailer-insights",
    description:
      "Desktop insights for retailers — spend trends, category and brand breakdowns, and purchase history.",
    owner: "Maggie Murphy",
    createdAt: "2026-09-15",
    lastUpdated: "2026-09-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ec502ab1a7c3855105008f2e41820b2c1bc5ec3461f45a1eba56f9ba5de4a2a3.png",
    creationTool: "cursor",
  },
  {
    id: "mm-brand-onboarding-happy-path",
    name: "Brand Onboarding Happy Path",
    path: "/mm/brand-onboarding-happy-path",
    description:
      "End-to-end happy path for brand onboarding, from sign-up through Shopify sync, using Suma Collective. Hide the LiveToolbar on camera with Shift+T.",
    owner: "Maggie Murphy",
    createdAt: "2026-09-30",
    lastUpdated: "2026-09-30",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/mm-brand-onboarding-happy-path.png",
  },
  {
    id: "mm-new-brand-benefits",
    name: "New Brand Benefits",
    path: "/mm/new-brand-benefits",
    description: "Brand home across pre-activation, go-live and post-activation new-brand-benefit states, with baseline vs new notifications panel.",
    owner: "Maggie Murphy",
    createdAt: "2026-10-06",
    lastUpdated: "2026-10-06",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/mm-new-brand-benefits.png",
  },
  {
    id: "mm-accept-order-banner",
    name: "Accept Order Banner",
    path: "/mm/accept-order-banner",
    description: "Brand accepts an order: New (unaccepted) order page with Review and accept card.",
    owner: "Maggie Murphy",
    createdAt: "2026-10-07",
    lastUpdated: "2026-10-07",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/mm-accept-order-banner.png",
  }
];
